(function(){
  'use strict';

  angular.module('eclipseApp.checkout').directive('fcCheckSlot', function(){
    return function($scope, $elem, $attr) {


      // remove id attribute if slotIndex == -1
      if ($scope.$eval($attr.fcCheckSlot) === -1 && $attr.id){
        _.defer(function(){
          $elem.removeAttr('id');
          $scope.$digest();
        });
      }
      
    }
  });
})();
